import React from 'react';
import styled from 'styled-components';
import ScrollReveal from './shared/ScrollReveal';

const Section = styled.section`
  padding: 64px 24px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: 48px 16px 32px;
  }
`;

const CTABlock = styled.div`
  text-align: center;
  max-width: 480px;
`;

const CTALabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${p => p.theme.gold};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const CTAHeading = styled.h2`
  font-size: 40px;
  font-weight: 600;
  color: ${p => p.theme.text};
  letter-spacing: -0.03em;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const CTASub = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: ${p => p.theme.textSecondary};
  margin-bottom: 32px;
`;

const PrimaryButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 32px;
  background: ${p => p.theme.gold};
  color: #0a0c10;
  font-size: 15px;
  font-weight: 600;
  font-family: ${p => p.theme.fontFamily};
  border-radius: ${p => p.theme.radius};
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;

  &:hover {
    opacity: 0.92;
    box-shadow: 0 0 40px rgba(229, 188, 42, 0.2);
    transform: translateY(-1px);
  }

  &:active {
    opacity: 0.85;
    transform: translateY(0);
  }
`;

export default function FooterCTA() {
  return (
    <Section>
      <ScrollReveal>
        <CTABlock>
          <CTALabel>TezLab Pro</CTALabel>
          <CTAHeading>One more reason to go Pro</CTAHeading>
          <CTASub>
            MCP comes with every TezLab Pro and Founders Series membership,
            alongside unlimited history, Car Reports, and everything else Pro unlocks.
            <br />
            Already a member? The setup guide above will get you connected.
          </CTASub>
          <PrimaryButton href="/subscribe">
            Get TezLab Pro &rarr;
          </PrimaryButton>
        </CTABlock>
      </ScrollReveal>
    </Section>
  );
}
